<template lang="pug">
div(
    :key="carouselKey"
    :class="{ 'max-w-[1920px] mx-auto w-full': data.type === 'BANNER' }"
)
    Carousel(v-bind="carouselOptions")
        template(v-for="(item, index) in data.items")
            ImageCarouselItem(
                :data="item"
                :labelPosition="data.labelPosition"
                :textColor="data.textColor"
                :textPosition="data.textPosition"
                :shadowOpacity="data.shadowOpacity"
                :shadowTopPosition="data.shadowTopPosition"
                :shadowBottomPosition="data.shadowBottomPosition"
                :class="[data.type === 'BANNER' ? 'w-full min-w-full' : 'flex-none']"
                :style="carouselItemStyle"
            )
                template(#default="{ widget }")
                    slot(
                        :data="widget"
                        :spaceLeft="carouselSpacePerItem"
                        :forceLazyLoad="data.type === 'BANNER' && index > 0"
                        :isImportant="data.type === 'BANNER' && index === 0"
                    )

</template>

<script>
import Carousel from '@/components/carousel'
import ImageCarouselItem from './imageCarouselItem'

export default {
    name: 'ImageCarouselWidget',
    components: {
        Carousel,
        ImageCarouselItem,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        // This is to make sure that the carousel re-renders everytime a new item is added or removed
        carouselKey() {
            return `${this.data._uid}-${this.data.items.length}`
        },
        carouselSpacePerItem() {
            const spaceLeftValue = 256
            if (this.data.type === 'CARD') {
                return {
                    mobile: spaceLeftValue,
                    tablet: spaceLeftValue,
                    desktop: spaceLeftValue,
                }
            } else if (this.data.type === 'CUSTOM') {
                const customSpaceLeft = {
                    mobile: spaceLeftValue,
                    tablet: spaceLeftValue,
                    desktop: spaceLeftValue,
                }
                const mobileCustomValue = parseInt(this.data.mobileCustomSize)
                const tabletCustomValue = parseInt(this.data.tabletCustomSize)
                const desktopCustomValue = parseInt(this.data.desktopCustomSize)

                if (mobileCustomValue) {
                    customSpaceLeft.mobile = mobileCustomValue
                    customSpaceLeft.tablet = mobileCustomValue
                    customSpaceLeft.desktop = mobileCustomValue
                }

                if (tabletCustomValue) {
                    customSpaceLeft.tablet = tabletCustomValue
                    customSpaceLeft.desktop = tabletCustomValue
                }

                if (desktopCustomValue) {
                    customSpaceLeft.desktop = desktopCustomValue
                }

                return customSpaceLeft
            }
            return null
        },
        carouselItemStyle() {
            if (this.data.type !== 'CUSTOM') return {}
            let width
            // Choose maxWidth value based upon device
            if (this.$device.isMobile) width = this.carouselSpacePerItem.mobile
            else if (this.$device.isDesktop) width = this.carouselSpacePerItem.desktop
            else width = this.carouselSpacePerItem.tablet

            return { width: `${width}px` }
        },
        carouselOptions() {
            const options = {}

            switch (this.data.type) {
                case 'BANNER':
                    options.arrowMode = this.$device.isDesktop ? 'HOVER' : 'ALWAYS'
                    options.isLooped = true
                    break

                default:
                    options.containerClass = 'gap-x-4'
                    break
            }

            return options
        },
    },
}
</script>
